import { api } from './client'

export interface Animal {
  id?: string
  name?: string
  species: string
  breed?: string
  gender: 'Male' | 'Female' | 'Neutered' | 'Other'
  neutered_date?: string | null
  acquisition_date: string
  acquisition_method: 'Purchase' | 'Birth' | 'Gift' | 'Exchange'
  health_status: 'Healthy' | 'Sick' | 'Injured' | 'Quarantined'
  symptoms?: string | null
  location: string
  count: number
  created_by?: string
  owner?: string
  created_by_name?: string
  owner_name?: string
  createdAt?: string
  updatedAt?: string
}

export interface PaginatedResponse<T> {
  count: number
  next: string | null
  previous: string | null
  results: T[]
}

interface PaginationParams {
  page?: number
  limit?: number
  offset?: number
  sortBy?: string
  order?: 'asc' | 'desc'
}

interface AnimalFilterParams extends PaginationParams {
  type?: string
  status?: string
  farmId?: string
  health?: string
  search?: string
}

export const animalService = {
  async registerAnimal(data: Omit<Animal, 'id' | 'created_by' | 'owner'>) {
    return api.post<Animal>('animals/', data)
  },

  async getAnimals(params?: AnimalFilterParams) {
    return api.get<PaginatedResponse<Animal>>('animals/', { params })
  },

  async getAnimal(id: string) {
    return api.get<Animal>(`animals/${id}/`)
  },

  async updateAnimal(id: string, data: Partial<Animal>) {
    return api.put<Animal>(`animals/${id}/`, data)
  },

  async deleteAnimal(id: string) {
    return api.delete(`animals/${id}/`)
  },

  async getAnimalStats() {
    return api.get<Record<string, number>>('animals/stats/')
  },

  async searchAnimals(query: string, limit = 5) {
    return api.get<Animal[]>(`animals/search/?q=${query}&limit=${limit}`)
  },
}
